export const TRANSLATIONS_TEMP = {
  it: {
    "La razza inserita non è tra quelle ammesse dal PMS":
      "La razza inserita non è tra quelle ammesse dal PMS",
    "Ultima modifica il [lastUpdated]": "Ultima modifica il {{lastUpdated}}",
    'I contatti mostrati sono quelli che rispettano i criteri della lista "[listName]"':
      'I contatti mostrati sono quelli che rispettano i criteri della lista "{{listName}}"',
    "Il PMS sta cercando fra tutti i tuoi contatti, l|operazione potrebbe richiedere tempo.":
      "Il PMS sta cercando fra tutti i tuoi contatti, l'operazione potrebbe richiedere tempo.",
    "I risultati mostrati sono una parte dell|elenco completo utilizzato durante l|esecuzione della campagna":
      "I risultati mostrati sono una parte dell'elenco completo utilizzato durante l'esecuzione della campagna",
    "Se però preferisci non riceverle più, puoi annullare l|iscrizione cliccando sul pulsante qui sotto.":
      "Se però preferisci non riceverle più, puoi annullare l'iscrizione cliccando sul pulsante qui sotto.",
    "Fattura [number] del [date]": "Fattura {{number}} del {{date}}",
    "Fattura [number] bozza": "Fattura {{number}} bozza",
    "ed altre [count]": "ed altre {{count}}",
    "ed altri [count]": "ed altri {{count}}",
    "variable-firstName": "Nome",
    "variable-lastName": "Cognome",
    "variable-email": "Email",
    "variable-phone": "Telefono",
    "variable-businessName": "Ragione sociale",
    "variable-ssn": "Codice fiscale",
    "variable-vatNumber": "Partita IVA",
    "Corretto un problema che in alcuni casi impediva un corretto posizionamento dell|agenda":
      "Corretto un problema che in alcuni casi impediva un corretto posizionamento dell'agenda",
    "IVA obbligatoria": "IVA obbligatoria",
    "Prezzo non valorizzato": "Prezzo non valorizzato",
    "Messo in conto": "Messo in conto",
    "Aggiungi un farmaco da modifica ricetta":
      "Aggiungi un farmaco da modifica ricetta",
    "Stampa fatture": "Stampa fatture",
    "La dimensione del documento è oltre i limiti di stampa":
      "La dimensione del documento è oltre i limiti di stampa",
    "Non è possibile stampare più di [limit] fatture":
      "Non è possibile stampare più di {{limit}} fatture",
    "Operazione in corso: [progress]%": "Operazione in corso: {{progress}}%",
    "Invia fatture": "Invia fatture",
    "Invio fatture in corso": "Invio fatture in corso",
    "Stampa [count] fatture di [name]": "Stampa {{count}} fatture di {{name}}",
    "Non è possibile stampare più di [limit] giorni di appuntamenti":
      "Non è possibile stampare più di {{limit}} giorni di appuntamenti",
    Ora: "Ora",
    Riconfezionamento: "Riconfezionamento",
    "Arrotondamento commerciale": "Arrotondamento commerciale",
    "Arrotondamento commerciale impostato in fattura":
      "Arrotondamento commerciale impostato in fattura",
    "Impossibile impostare l'arrotondamento commerciale in fattura":
      "Impossibile impostare l'arrotondamento commerciale in fattura",
    "Arrotondamento commerciale disabilitato in fattura":
      "Arrotondamento commerciale disabilitato in fattura",
    "Impossibile disabilitare l'arrotondamento commerciale in fattura":
      "Impossibile disabilitare l'arrotondamento commerciale in fattura",
    "Piano dei conti": "Piano dei conti",
    "Codice Ditta": "Codice Ditta",
    "Conto Cliente (ricavi)": "Conto Cliente (ricavi)",
    "Conto Fornitore (costi)": "Conto Fornitore (costi)",
    "IVA Vendita": "IVA Vendita",
    "Conto con Ritenuta d'acconto": "Conto con Ritenuta d'acconto",
    "Conto senza Ritenuta d'acconto": "Conto senza Ritenuta d'acconto",
    "Conto esente IVA": "Conto esente IVA",
    "Conto predefinito": "Conto predefinito",
    "Conto prestazioni veterinarie - IVA 22%":
      "Conto prestazioni veterinarie - IVA 22%",
    "Conto cessione farmaci - IVA 10%": "Conto cessione farmaci - IVA 10%",
    "Conto articoli vari/prodotti - IVA 4%":
      "Conto articoli vari/prodotti - IVA 4%",
    "Cassa contanti": "Cassa contanti",
    Banca: "Banca",
    "Codici IVA": "Codici IVA",
    "Conti ricavo netto (imponibili)": "Conti ricavo netto (imponibili)",
    "Conti patrimoniali": "Conti patrimoniali",
    Posizione: "Posizione",
    "member-medical": "Medico",
    "member-administrative": "Amministrativo",
    Assistente: "Assistente",
    "Eseguito da fatturare": "Eseguito da fatturare",
    "Eseguito totale": "Eseguito totale",
    "Aggiunta l|azione condividi nel dettaglio della ricetta":
      "Aggiunta l'azione condividi nel dettaglio della ricetta",
    "Corretto un problema che in alcuni casi impediva l|aggiornamento di un preventivo dopo la modifica del prezzo massimo di un elemento":
      "Corretto un problema che in alcuni casi impediva l'aggiornamento di un preventivo dopo la modifica del prezzo massimo di un elemento",
    "Corretto un problema che impediva di navigare alla data odierna nell|agenda":
      "Corretto un problema che impediva di navigare alla data odierna nell'agenda",
    "Per l'appuntamento sono stati configurati un telefono e/o una mail differenti da quelli in anagrafica, vuoi aggiornarli?":
      "Per l'appuntamento sono stati configurati un telefono e/o una mail differenti da quelli in anagrafica, vuoi aggiornarli?",
    "Per procedere, specificare il sesso":
      "Per procedere, specificare il sesso",
    "Inserito da": "Inserito da",
    Quantita: "Quantità",
    "Corretto un problema nell|esportazione dei pazienti":
      "Corretto un problema nell'esportazione dei pazienti",
    "Sono presenti delle notule importate":
      "Sono presenti delle notule importate",
    "Notula esistente": "Notula esistente",
    "Esiste già una notula per questo cliente.":
      "Esiste già una notula per questo cliente.",
    "Trovata una notula sul cliente": "Trovata una notula sul cliente",
    "Continua la fatturazione nella notula esistente. Le prestazioni verranno aggiunte alla notula.":
      "Continua la fatturazione nella notula esistente. Le prestazioni verranno aggiunte alla notula.",
    Apri: "Apri",
    "Crea nuova fattura": "Crea nuova fattura",
    Annulla: "Annulla",
    "Primo semestre": "Primo semestre",
    "Secondo semestre": "Secondo semestre",
    Allega: "Allega",
    "Inserito il [date]": "Inserito il {{date}}",
    "Esporta le righe di fattura per metodo di pagamento selezionate in Excel":
      "Esporta le righe di fattura per metodo di pagamento selezionate in Excel",
    "Visualizza condizioni d|uso del modulo API":
      "Visualizza condizioni d'uso del modulo API",
    "Accetto le condizioni d|uso": "Accetto le condizioni d'uso",
    "E| necessario visulizzare le condizioni d|uso per procedere":
      "E' necessario visulizzare le condizioni d'uso per procedere",
    "Caricato [loaded] di [total]": "Caricato {{loaded}} di {{total}}",
    "Impossibile creare l|ordine": "Impossibile creare l'ordine",
    "Ordine #[number]": "Ordine #{{number}}",
    "Periodo compreso tra il [from] ed il [to]":
      "Periodo compreso tra il {{from}} ed il {{to}}",
    "Impossibile aggiungere l'acconto selezionato":
      "Impossibile aggiungere l'acconto selezionato",
    "Impossibile caricare i dati di utilizzo":
      "Impossibile caricare i dati di utilizzo",
    "Impossibile caricare l'API key": "Impossibile caricare l'API key",
    Integrazione: "Integrazione",
    "Copiato negli appunti": "Copiato negli appunti",
    Copia: "Copia",
    "Le due modalità sono alternative e dipendono dallo strumento utilizzato":
      "Le due modalità sono alternative e dipendono dallo strumento utilizzato",
    "Metodo 1: Header x-api-key": "Metodo 1: Header x-api-key",
    "Metodo 2: Parametro query apiKey": "Metodo 2: Parametro query apiKey",
    "URL MCP": "URL MCP",
    "API Key": "API Key",
    "Esempio URL completo": "Esempio URL completo",
    "Header da impostare: x-api-key": "Header da impostare: x-api-key",
    "Intro integrazione MCP":
      "Puoi integrare Snoots MCP in due modi. Scegli il metodo in base allo strumento che usi: alcuni supportano header HTTP personalizzati, altri accettano solo un URL con parametri.",
    "Intro metodo header":
      "Usa questa modalità se il tuo strumento supporta l'impostazione di header HTTP personalizzati.",
    "Nota metodo header":
      "L'API key viene inviata nell'header x-api-key ad ogni richiesta. Più sicuro perché la chiave non appare nell'URL.",
    "Intro metodo query":
      "Usa questa modalità se il tuo strumento accetta solo un URL e non permette di configurare header aggiuntivi.",
    "Nota metodo query":
      "L'API key è inclusa nell'URL. Evita di condividere l'URL completo poiché contiene la chiave.",
    "Hai utilizzato un acconto incassato con un profilo fiscale differente.":
      "Hai utilizzato un acconto incassato con un profilo fiscale differente.",
    "L'acconto presenta i seguenti parziali già assegnati:":
      "L'acconto presenta i seguenti parziali già assegnati:",
    "L'acconto è già assegnato in una notula:":
      "L'acconto è già assegnato in una notula:",
    "Performance economica": "Performance economica",
    "Clienti e pazienti": "Clienti e pazienti",
    "Efficienza operativa": "Efficienza operativa",
    "Qualità e soddisfazione": "Qualità e soddisfazione",
    "Ticket medio": "Ticket medio",
    "Fatturato medio per contatto": "Fatturato medio per contatto",
    "Fatturato medio per paziente": "Fatturato medio per paziente",
    "Pazienti entrati in clinica": "Pazienti entrati in clinica",
    "Tasso di crescita contatti": "Tasso di crescita contatti",
    "Prestazioni per paziente": "Prestazioni per paziente",
    "Tempo di attesa medio": "Tempo di attesa medio",
    "Tempo di permanenza medio": "Tempo di permanenza medio",
    "Soddisfazione clienti": "Soddisfazione clienti",
    "Più opzioni": "Più opzioni",
    "Valore medio delle fatture": "Valore medio delle fatture",
    "Importo medio fatturato per contatto":
      "Importo medio fatturato per contatto",
    "Importo medio fatturato da ciascun veterinario":
      "Importo medio fatturato da ciascun veterinario",
    "Importo medio fatturato per ogni paziente":
      "Importo medio fatturato per ogni paziente",
    "Numero di pazienti entrati in clinica nel periodo":
      "Numero di pazienti entrati in clinica nel periodo",
    "Rapporto tra numero di pretazione e numero di pazienti":
      "Rapporto tra numero di pretazione e numero di pazienti",
    "Media durata in minuti, eccetto i pazienti in degenza":
      "Media durata in minuti, eccetto i pazienti in degenza",
    "Media della soddisfazione cliente nel periodo":
      "Media della soddisfazione cliente nel periodo",
    "L|interruzione è stata completamente risolta. Il servizio è tornato pienamente operativo. Ti ringraziamo per la pazienza.":
      "L'interruzione è stata completamente risolta. Il servizio è tornato pienamente operativo. Ti ringraziamo per la pazienza.",
    "L|interruzione parziale è stata risolta. Il servizio è ora pienamente operativo. Ti ringraziamo per la pazienza.":
      "L'interruzione parziale è stata risolta. Il servizio è ora pienamente operativo. Ti ringraziamo per la pazienza.",
    "Il servizio sta subendo un|interruzione parziale. Alcune funzionalità potrebbero non essere momentaneamente disponibili. Stiamo lavorando per ripristinare la piena operatività.":
      "Il servizio sta subendo un'interruzione parziale. Alcune funzionalità potrebbero non essere momentaneamente disponibili. Stiamo lavorando per ripristinare la piena operatività.",
    "L|interruzione principale è stata parzialmente risolta. Alcune funzionalità restano temporaneamente non disponibili. Stiamo continuando a lavorare per il completo ripristino del servizio.":
      "L'interruzione principale è stata parzialmente risolta. Alcune funzionalità restano temporaneamente non disponibili. Stiamo continuando a lavorare per il completo ripristino del servizio.",
    "Il servizio sta subendo un|interruzione significativa. Alcune o tutte le funzionalità potrebbero non essere disponibili. Stiamo lavorando per risolvere il problema il prima possibile.":
      "Il servizio sta subendo un'interruzione significativa. Alcune o tutte le funzionalità potrebbero non essere disponibili. Stiamo lavorando per risolvere il problema il prima possibile.",
    "[number] del [emittedAt]": "{{number}} del {{emittedAt}}",
    e: "e",
    giorno: "giorno",
    giorni: "giorni",
    mese: "mese",
    mesi: "mesi",
    anno: "anno",
    anni: "anni",
    "Totale: [value]": "Totale: {{value}}",
    "Fatture insolute: [value]": "Fatture insolute: {{value}}",
    "Clienti insoluti al [date]": "Clienti insoluti al {{date}}",
    "Totale fatturato: [value]": "Totale fatturato: {{value}}",
    "Totale incassato: [value]": "Totale incassato: {{value}}",
    "Totale insoluto: [value]": "Totale insoluto: {{value}}",
    "Totale crediti utilizzati": "Totale crediti utilizzati",
    "Fatture insolute di [nominative] al [date]":
      "Fatture insolute di {{nominative}} al {{date}}",
    "La fattura non è compatibile con il regime forfettario scelto: alcune prestazioni non sono esenti IVA. Procedere comunque?":
      "La fattura non è compatibile con il regime forfettario scelto: alcune prestazioni non sono esenti IVA. Procedere comunque?",
    "Ordine n° [orderNumber] inserito con successo!":
      "Ordine n° {{orderNumber}} inserito con successo!",
    "Completa l|acquisto": "Completa l'acquisto",
    'Cliccando su "Completa l|acquisto" accetti l|ordine e ti impegni a pagare l|importo indicato.':
      "Cliccando su \"Completa l'acquisto\" accetti l'ordine e ti impegni a pagare l'importo indicato.",
    "[name] importato": "{{name}} importato",
    "study-in-acquisition": "In acquisizione",
    "IVA [value]": "IVA {{value}}",
    "Abilita per continuare": "Abilita per continuare",
    "Seleziona un provider per compilare i campi":
      "Seleziona un provider per compilare i campi",
    "Il paziente ha un acconto non ancora consumato":
      "Il paziente ha un acconto non ancora consumato",
    "È stato trovato un acconto di [remainingAmount] non ancora utilizzato.":
      "È stato trovato un pagamento anticipato di {{remainingAmount}} non ancora utilizzato.",
    "Non mostrare più": "Non mostrare più",
    "Crediti per invio email esauriti": "Crediti per invio email esauriti",
    Autorizzazioni: "Autorizzazioni",
    "I campi contrassegnati con • sono necessari per l'esportazione verso Zucchetti o Team System.":
      "I campi contrassegnati con • sono necessari per l'esportazione verso Zucchetti o Team System.",
    Gratuito: "Gratuito",
    "Cerca per nome o descrizione…": "Cerca per nome o descrizione…",
    Criterio: "Criterio",
    Destinatario: "Destinatario",
    "changelog.advanced.title": "Cosa c'è di nuovo",
    "changelog.advanced.subtitle.v143":
      "Agenda rinnovata, ruoli, fatturazione guidata e nuovi connettori",
    "changelog.advanced.brand.pms": "Snoots PMS",
    "changelog.advanced.helpCenter": "Help Center →",
    "changelog.advanced.footer.v143": "Aprile 2026 · Snoots PMS",
    "changelog.advanced.stat.agenda": "Novità agenda",
    "changelog.advanced.stat.users": "Utenti & ruoli",
    "changelog.advanced.stat.connectors": "Connettori",
    "changelog.advanced.stat.ux": "Usabilità",
    "changelog.advanced.stat.invoicing": "Fatturazione",
    "changelog.advanced.tab.agenda": "Agenda",
    "changelog.advanced.tab.users": "Utenti",
    "changelog.advanced.tab.billing": "Fatturazione",
    "changelog.advanced.tab.ux": "Usabilità",
    "changelog.advanced.tab.connectors": "Connettori",
    "changelog.advanced.tab.ai": "AI",
    "changelog.advanced.stat.ai": "AI",
    "changelog.advanced.ai.snt10001":
      "Introduzione MCP all'interno del Marketplace di Snoots",
    "changelog.advanced.section.agenda": "Agenda e scheduler",
    "changelog.advanced.section.users": "Gestione utenti e ruoli",
    "changelog.advanced.section.billing": "Fatturazione e contabilità",
    "changelog.advanced.section.ux": "Miglioramenti di usabilità",
    "changelog.advanced.section.connectors": "Nuovi connettori e integrazioni",
    "changelog.advanced.agenda.snt10025":
      "Divisione dello scheduler per reparti: ogni reparto ha la propria vista",
    "changelog.advanced.agenda.snt10023":
      "Gli appuntamenti mostrano il colore del medico assegnato",
    "changelog.advanced.agenda.snt10022":
      "Nome e cognome del medico per intero negli appuntamenti",
    "changelog.advanced.agenda.snt10026":
      "Indicazione di chi è in turno direttamente in agenda",
    "changelog.advanced.agenda.snt10168":
      "Ricerca e filtro degli appuntamenti per reparto",
    "changelog.advanced.agenda.snt10170":
      "Filtro scheduler per risorse prenotabili e reparti",
    "changelog.advanced.users.snt10162":
      "Nuova interfaccia per modifica di utenti, ruoli e autorizzazioni",
    "changelog.advanced.users.snt10165":
      "Ogni profilo utente include ora ruolo, colore e reparto di appartenenza",
    "changelog.advanced.users.snt10166":
      "Tag reparto per categorizzare rapidamente lo staff",
    "changelog.advanced.users.snt10167":
      "Colonna reparto aggiunta nella lista utenti",
    "changelog.advanced.users.snt10169":
      "Colonna che indica se l'utente è configurato come prenotabile",
    "changelog.advanced.billing.snt9826":
      "Emissione guidata delle fatture: flusso step-by-step fino all'invio",
    "changelog.advanced.billing.snt10124":
      "Alert automatico sui preventivi non aggiornati dopo modifiche al tariffario",
    "changelog.advanced.billing.snt10242":
      "Gestione notule direttamente sul profilo cliente",
    "changelog.advanced.ux.snt9966":
      "PIN di accesso: caratteri nascosti durante la digitazione",
    "changelog.advanced.ux.snt10014":
      '"Seleziona tutto" nel diario clinico per operazioni rapide',
    "changelog.advanced.ux.snt10020":
      "Link diretto all'Help Center accessibile dal PMS",
    "changelog.advanced.ux.snt10108":
      "Conferma esplicita prima di eliminare una cartella clinica",
    "changelog.advanced.ux.snt9294":
      'Campo "eseguito da" selezionabile direttamente dal preventivo',
    "changelog.advanced.ux.snt10033":
      "Grado di soddisfazione cliente visibile nell'anagrafica contatto",
    "changelog.advanced.ux.snt10200":
      "Consegna studi diagnostici al proprietario direttamente dal PMS",
    "changelog.advanced.connector.snt8828": "SNT-8828 · Commercialista",
    "changelog.advanced.connector.snt9726": "SNT-9726 · Laboratorio",
    "changelog.advanced.connector.snt9720": "SNT-9720 · Analizzatore",
    "changelog.advanced.connector.snt9389": "SNT-9389 · Antibiotici",
    "changelog.advanced.connector.snt10224": "SNT-10224 · Biochimico",
    "changelog.advanced.connector.snt10225": "SNT-10225 · Elettroforesi",
    "changelog.advanced.connector.snt10226": "SNT-10226 · Coagulativo",
    "changelog.advanced.connector.snt10227": "SNT-10227 · Ormonali",
    "changelog.advanced.subtitle.v14336":
      "Acconti, notule numerate, assegna a dal preventivo e nuove scorciatoie",
    "changelog.advanced.footer.v14336": "Maggio 2026 · Snoots PMS",
    "changelog.advanced.stat.newFeatures": "Nuove funzioni",
    "changelog.advanced.stat.improvements": "Migliorie",
    "changelog.advanced.stat.fixesRelease": "Correzioni",
    "changelog.advanced.tab.video": "▶ Video",
    "changelog.advanced.tab.fixes": "Correzioni",
    "changelog.advanced.tabCount.new": "NEW",
    "changelog.advanced.v14336.video.heading": "📹 Video della release",
    "changelog.advanced.v14336.video.caption":
      "Guarda le novità di questa release",
    "changelog.advanced.v14336.video.openYoutube": "Apri su YouTube →",
    "changelog.advanced.v14336.video.inThisVideo": "In questo video",
    "changelog.advanced.v14336.video.bullet.1":
      "Panoramica delle novità principali della release v1.43.37",
    "changelog.advanced.v14336.video.bullet.2":
      "Demo delle funzionalità più richieste",
    "changelog.advanced.v14336.video.bullet.3":
      "Consigli d'uso e best practice",
    "changelog.advanced.v14336.ux.1":
      "Ripristino visualizzazione acconti da scheda cliente",
    "changelog.advanced.v14336.ux.2":
      "Colore tag statistiche fatturato ora resta fisso per una maggiore facilità d'uso",
    "changelog.advanced.v14336.billing.1":
      'Possibilità di selezionare l\'"Assegna a" direttamente dal preventivo',
    "changelog.advanced.v14336.billing.2":
      "Le notule sono ora numerate per un'identificazione più semplice",
    "changelog.advanced.v14336.billing.3":
      "Possibilità di inviare una mail direttamente dal gestionale cliccando sull'indirizzo email del cliente",
    "changelog.advanced.v14336.fixes.section": "Correzioni minori",
    "changelog.advanced.v14336.fixes.summary":
      "correzioni minori applicate in questa release per una maggiore stabilità e affidabilità del gestionale.",
    "changelog.advanced.subtitle.v14342":
      "Novità sulla stampa documenti — guarda il video per i dettagli",
    "changelog.advanced.footer.v14342": "Maggio 2026 · Snoots PMS",
    "changelog.advanced.stat.printRelease": "Stampa",
    "changelog.advanced.tab.print": "Stampa",
    "changelog.advanced.v14342.video.heading": "📹 Video della release",
    "changelog.advanced.v14342.video.caption":
      "Guarda le novità di questa release",
    "changelog.advanced.v14342.video.openYoutube": "Apri su YouTube →",
    "changelog.advanced.v14342.video.detailsHeading": "In questa release",
    "changelog.advanced.v14342.print.1":
      "Rimosso il limite di stampa dei documenti",
    "member-technical": "Tecnico",
    "Totale insoluto": "Totale insoluto",
    "Stampa riepilogo": "Stampa riepilogo",
    "Visualizza risultato": "Visualizza risultato",
    "Sei sicuro di voler eliminare [count] notule?":
      "Sei sicuro di voler eliminare {{count}} notule?",
    "Elimina notule": "Elimina notule",
    "Bozza n. [number]": "Bozza n. {{number}}",
    "Check In rapido": "Check In rapido",
    "Scegliere cosa includere nella stampa:":
      "Scegliere cosa includere nella stampa:",
    "Tutte le voci (fatturate e da fatturare)":
      "Tutte le voci (fatturate e da fatturare)",
    "Solo voci da fatturare": "Solo voci da fatturare",
    "Solo voci già fatturate": "Solo voci già fatturate"
  },
  en: {
    Bozza: "Draft",
    "Bozza n. [number]": "Draft n. {{number}}",
    "member-technical": "Technical",
    "member-administrative": "Administrative",
    "member-medical": "Medical",
    "IVA [value]": "VAT {{value}}",
    "study-in-acquisition": "In acquisition",
    "[name] importato": "{{name}} imported",
    "Codice fiscale non coerente con i dati anagrafici inseriti":
      "The fiscal code doesn't match the information provided",
    "Ci sono delle prestazioni da fatturare":
      "There are medical services to be billed",
    "Menziona in un task": "Tag on a task",
    "Non ci sono fatture insolute": "There aren't any overdue invoices",
    Pagina: "Page",
    "Totale fatturato": "Total billed",
    "Clienti insoluti": "Overdue customers",
    "Ci sono delle fatture insolute": "There is at least one overdue invoice",
    Insoluto: "Outstanding",
    "Fatture insolute": "Overdue invoices",
    "Tel.": "Phone",
    "Scaduta il": "Expired on",
    "Fatture insolute di [nominative] al [date]":
      "Overdue invoices of {{nominative}} as of {{date}}",
    "Clienti insoluti al [date]": "Overdue customers as of {{date}}",
    "Totale fatturato: [value]": "Total billed: {{value}}",
    "Totale incassato: [value]": "Total collected: {{value}}",
    "Totale insoluto: [value]": "Total outstanding: {{value}}",
    "Fatture insolute: [value]": "Overdue invoices: {{value}}",
    "Totale: [value]": "Total: {{value}}",
    "Totale crediti utilizzati": "Total credits used",
    "[number] del [emittedAt]": "{{number}} of {{emittedAt}}",
    "Cerca per nome...": "Search by name...",
    "Cerca per nome o descrizione…": "Search by name or description…",
    Criterio: "Criterion",
    Destinatario: "Target",
    "Inserimento ordine in corso...": "Order insertion in progress...",
    "Vai i miei ordini": "Go to my orders",
    "Dati fatturazione": "Billing data",
    "Email di fatturazione": "Billing email",
    "Verrai automaticamente reindirizzato alla pagina dei miei ordini in 5 secondi...":
      "You will be automatically redirected to my orders page in 5 seconds...",
    'Cliccando su "Completa l|acquisto" accetti l|ordine e ti impegni a pagare l|importo indicato.':
      'By clicking on "Complete purchase" you accept the order and undertake to pay the amount indicated.',
    "Polo di erogazione": "Delivery point",
    Creati: "Created",
    "Vai al servizio": "Go to service",
    "Dati estratti dallo studio": "Data extracted from the study",
    "Fee transazione": "Transaction fee",
    "Transazione #": "Transaction #",
    "Effettuata il": "Made on",
    "Parzialmente completato": "Partially completed",
    Consegnato: "Delivered",
    "In attesa": "In progress",
    "In coda": "In queue",
    "Upload in corso": "Uploading in progress",
    Caricato: "Loaded",
    Errore: "Error",
    Rimuovi: "Remove",
    "I miei ordini": "My orders",
    "In Lavorazione": "In progress",
    Completato: "Done",
    Assegnato: "Assigned",
    "Il carrello è vuoto": "The cart is empty",
    "Aggiungi dei servizi per iniziare": "Add services to start",
    "Completa l|acquisto": "Complete the purchase",
    "Aggiungi al carrello": "Add to cart",
    Diagnostico: "Diagnostic",
    Catalogo: "Catalog",
    Spese: "Expenses",
    Completati: "Done",
    "Ricevi qui i tuoi referti": "Receive your reports here",
    "Cerca negli ordini...": "Search in orders...",
    "Medico refertatore": "Referral doctor",
    "Scegli il medico refertatore": "Choose the referral doctor",
    Carrello: "Cart",
    "Aggiungi altri servizi": "Add more services",
    "Corretto un problema nella geatione dei turni":
      "Fixed a problem in shifts manager",
    "Ordine n° [orderNumber] inserito con successo!":
      "Order n° {{orderNumber}} inserted successfully!",
    "Non hai sufficiente spazio disponibile nel disco": "Disk space is low",
    "Migliorata la gestione del pin e lo sblocco della sessione":
      +"Better pin management and session unlock",
    "Migliorati i tab, ora sono sempre tutti visibili":
      "Tabs are now always visible",
    "Corretto un problema nelle statistiche con gli importi in negativo":
      "Fixed a problem with negative amounts in statistics",
    "Aggiunta possibilità di retrodatare i vaccini":
      "Added the possibility to go back in time for vaccines",
    "Corretto un problema nella pagina di dettaglio delle fatture passive":
      "Fixed a problem in the passive invoice details page",
    "Migliorate le performance in export fatture":
      "Improved performance in invoice exports",
    "Il servizio è pienamente operativo. Tutte le funzionalità sono disponibili.":
      "The service is fully operational. All features are available.",
    "Clicca per visualizzare maggiori dettagli": "Click to view more details",
    "L|interruzione è stata completamente risolta. Il servizio è tornato pienamente operativo. Ti ringraziamo per la pazienza.":
      "The outage has been fully resolved. The service is now fully operational. Thank you for your patience.",
    "L|interruzione parziale è stata risolta. Il servizio è ora pienamente operativo. Ti ringraziamo per la pazienza.":
      "The partial outage has been resolved. The service is now fully operational. Thank you for your patience.",
    "Il servizio sta subendo un|interruzione parziale. Alcune funzionalità potrebbero non essere momentaneamente disponibili. Stiamo lavorando per ripristinare la piena operatività.":
      "The service is currently undergoing a partial outage. Some features may be temporarily unavailable. We are working to restore full operational capacity.",
    "L|interruzione principale è stata parzialmente risolta. Alcune funzionalità restano temporaneamente non disponibili. Stiamo continuando a lavorare per il completo ripristino del servizio.":
      "The primary outage has been partially resolved. Some features remain temporarily unavailable. We are continuing to work to restore full operational capacity.",
    "Il servizio sta subendo un|interruzione significativa. Alcune o tutte le funzionalità potrebbero non essere disponibili. Stiamo lavorando per risolvere il problema il prima possibile.":
      "The service is currently undergoing a significant outage. Some or all features may be unavailable. We are working to resolve the issue as soon as possible.",
    "Corretto un problema relativo alla flowboard":
      "Fixed an issue related to the flowboard",
    "Corretto un problema nella visualizzazione delle checklist nelle schede SOAP":
      "Fixed a problem with the display of checklists in the SOAP cards",
    "Aggiunti i KPI": "Added KPI",
    "Aggiunta la possibilità di creare un collegamento ad un contato o ad un paziente in un task":
      "Added the possibility to create a link to a contact or a patient in a task",
    "Aggiunta la possibilità di stampare massivamente le fatture":
      "Added the possibility to print invoices in bulk",
    "Aggiunta la possibilità di filtrare gli elementi presenti nella flowboard":
      "Added the possibility to filter elements present in the flowboard",
    "Migliorata la visiilità delle ferie in agenda":
      "Improved the visibility of holidays in agenda",
    "Aggiunta la possibilità di cercare i contatti tramite numero identificativo":
      "Added the possibility to search contacts by identification number",
    "Corretti alcuni problemi relativi ai ricoveri":
      "Fixed some issues related to recoveries",
    "Apportati alcuni miglioramenti alle statistiche":
      "Added some improvements to statistics",
    "Corretti alcuni problemi nella visualizzazione dei turni in agenda":
      "Fixed some issues with the display of shifts in agenda",
    "Periodo compreso tra il [from] ed il [to]":
      "Period between {{from}} and {{to}}",
    "Attendere il completamento della stampa prima di chiudere la pagina":
      "Please wait for printing to complete before closing the page.",
    "E| necessario visulizzare le condizioni d|uso per procedere":
      "Required to view terms of use to proceed",
    "Accetto le condizioni d|uso": "Accept terms of use",
    "Visualizza condizioni d|uso del modulo API": "View API terms of use",
    "Corretto un problema che in alcuni casi impediva di inviare e stampare i documenti allegati al paziente":
      "Fixed a problem that in some cases prevented sending and printing attached documents to a patient",
    "Ora la stampa degli appuntamenti in agenda è allineata ai filtri in uso":
      "Appointments printing in agenda is now aligned with the filters in use",
    "Inserito il [date]": "Added on {{date}}",
    "Ordine #[number]": "Order #{{number}}",
    "Corretto un problema nell|esportazione dei pazienti":
      "Fixed a problem with the export of patients",
    "Impossibile creare l|ordine": "Unable to create the order",
    "Caricato [loaded] di [total]": "Loaded {{loaded}} of {{total}}",
    Quantita: "Quantity",
    "Fatturato totale": "Total sales",
    "Nuovi clienti": "New customers",
    "Per specie": "By species",
    Staff: "Staff",
    "Per aliquota": "By VAT rate",
    "Per centro di ricavo": "By revenue centre",
    "Per metodo di pagamento": "By payment method",
    Giorni: "Days",
    "Confronto per anni": "Comparison per years",
    "Nuovi pazienti per specie": "New patients by species",
    "Check-in per specie": "Check-in by species",
    "Seleziona anni": "Select years",
    "Corretti alcuni problemi nelle statistiche":
      "Fixed some issues in statistics",
    "Aggiunti i filtri nella sezione dei promemoria inseriti":
      "Added filters in the inserted reminders section",
    "Aggiunto il dettaglio di una scheda clinica di tipo laboratorio":
      "Added details of a laboratory clinical card",
    "Revisione delle statistiche": "Statistics review",
    "Aggiunta la possibilità di confrontare nello statistiche lo stesso periodo su più anni":
      "Added the possibility to compare the same period in more years in the statistics",
    "Nello scheduler ora è possibile attivare la visualizzazione solo per turni dello staff":
      "From the scheduler it is possible to activate the display only for staff shifts",
    "Aggiunto il codice cliente nel file di esportazione":
      "Added the customer code in the export file",
    "Rimossi i conti paziente datati sul conto di cassa aperto":
      "Removed patient accounts that are linked to the open cash account",
    "Aggiunto un avviso nel caso in cui un paziente abbia una razza non prevista in Snoots PMS":
      "Added warning in case a patient has a breed not provided in Snoots PMS",
    "La razza inserita non è tra quelle ammesse dal PMS":
      "The breed entered is not among those allowed by the PMS",
    "Aggiunto un avviso nel caso in cui la razza di un paziente non sia tra quelle previste in Snoots PMS":
      "Added warning in case a patient's breed is not among the ones provided in Snoots PMS",
    "Nella versione mobile non è possibile selezionare più di due mmebri dello staff":
      "Nella versione mobile non è possibile selezionare più di due membri dello staff",
    "Corretto un problema che in alcuni casi mostrava orari errati negli appuntamenti della flowboard":
      "Fixed a problem that in some cases showed wrong times on appointments in flowboard",
    "Corretto un problema che posizionava in maniera errata il popup per la creazione di un nuovo appuntamento":
      "Fixed a problem that positioned incorrectly the popup for creating a new appointment",
    "Corretto un problema che impediva di navigare alla data odierna nell|agenda":
      "Fixed a problem that prevented navigating to today's date in the agenda",
    "Corretto un problema che impediva la visualizzazione delle note nei ticket":
      "Fixed a problem that prevented note display in tickets",
    "Nuovo aggiornamento": "New update",
    "Snoots PMS è stato aggiornato! Per non perderti le ultime novità e miglioramenti ricarica ora il PMS!":
      "Snoots PMS has been updated! Don't miss the latest news and improvements! Reload the PMS now!",
    "Rocket è stato aggiornato! Per non perderti le ultime novità e miglioramenti ricarica ora!":
      "Rocket has been updated! Don't miss the latest news and improvements! Reload now!",
    "Aggiunta l|azione condividi nel dettaglio della ricetta":
      "Added share action in recipe details",
    "Aggiunto il filtro per motivo di scarico nei movimenti di uno storage":
      "Added download reason filter in one storage movement",
    "Aggiunta la data di nascita nella modifica di un contatto":
      "Added birth date in contact modification",
    "Aggiunta la possibilità di non visualizzare i nomi del personale non medico che ha effettuato le prestazioni":
      "Added option to hide non medical staff names",
    "Ora sono visibili con maggior evidenza gli appuntamenti annullati nella dashboard e nella flowboard":
      "Appointments cancelled are now more visible on the dashboard and flowboard",
    'Aggiunto lo stato "Fatturato" nel preventivo':
      "Added status 'Billed' in the quote",
    "Aggiunta la stampa degli appuntamenti in agenda":
      "Added appointments printing in agenda",
    "Corretto un problema che in alcuni casi impediva il caricamento del prezzo di un farmaco inserito tramite scansione":
      "Fixed a problem that in some cases prevented the loading of a drug price inserted by scan",
    "Corretto un problema che in alcuni casi impediva l|aggiornamento di un preventivo dopo la modifica del prezzo massimo di un elemento":
      "Fixed a problem that in some cases prevented the update of a quote after changing the maximum price of an element",
    "Includi ricevuta di pagamento": "Include payment receipt",
    "Ricevuta di pagamento": "Payment receipt",
    "Metodo di pagamento": "Payment method",
    Data: "Date",
    "Importo incassato": "Amount collected",
    "Seleziona il tenant con cui accedere": "Select the tenant to access",
    oppure: "or",
    "Corretto un problema che in alcuni casi impediva un corretto posizionamento dell|agenda":
      "Fixed a problem that in some cases prevented a correct positioning of the agenda",
    "Corretto un problema nel calcolo delle statistiche delle campagne":
      "Fixed a problem with the calculation of campaign statistics",
    "Comunicazioni - Modifica campagna": "Campaigns - Edit campaign",
    "Clicca qui": "Click here",
    "per non ricevere più queste email": "to not receive these emails anymore",
    Consegnate: "Delivered",
    "Sottoscrizioni annullate": "Subscriptions cancelled",
    "Non consegnate": "Not delivered",
    "In errore": "In error",
    Lette: "Read",
    "Insoluto da 30 giorni": "Unpaid for 30 days",
    "Insoluto da 60 giorni": "Unpaid for 60 days",
    "Insoluto da 90 giorni": "Unpaid for 90 days",
    "Insoluto da 120 giorni": "Unpaid for 120 days",
    "Clienti con un cane": "Customers with a dog",
    "Clienti con un gatto": "Customers with a cat",
    Personalizzato: "Custom",
    "variable-firstName": "Firstnam",
    "variable-lastName": "Lastname",
    "variable-email": "Email",
    "variable-phone": "Phone",
    "variable-businessName": "Business name",
    "variable-ssn": "Fiscal code",
    "variable-vatNumber": "Tax number",
    "ed altre [count]": "and other {{count}}",
    "ed altri [count]": "and other {{count}}",
    "Fattura [number] bozza": "Invoice {{number}} draft",
    "Fattura [number] del [date]": "Invoice {{number}} of {{date}}",
    "Ci dispiace vederti andare": "Sorry to see you go",
    "Siamo spiacenti che tu stia pensando di annullare l'iscrizione.":
      "Sorry we are sorry that you are thinking of unsubscribing",
    "Le nostre comunicazioni sono pensate per aiutarti a prenderti cura al meglio della salute del tuo animale.":
      "Our communications are designed to help you take care of your pet's health.",
    "Se però preferisci non riceverle più, puoi annullare l|iscrizione cliccando sul pulsante qui sotto.":
      "If you still prefer not to receive them anymore, you can unsubscribe by clicking the button below.",
    "Ultima modifica il [lastUpdated]": "Last updated on {{lastUpdated}}",
    'I contatti mostrati sono quelli che rispettano i criteri della lista "[listName]"':
      'Contacts shown are those that meet the criteria of the list "[listName]"',
    "Pianifica almeno una campagna": "Schedule at least one campaign",
    "Il PMS sta cercando fra tutti i tuoi contatti, l|operazione potrebbe richiedere tempo.":
      "The PMS is searching among all your contacts, the operation may take time.",
    "I risultati mostrati sono una parte dell|elenco completo utilizzato durante l|esecuzione della campagna":
      "The results shown are a part of the complete list used during the campaign",
    "IVA obbligatoria": "VAT required",
    "Prezzo non valorizzato": "Price required",
    "Messo in conto": "Added to book",
    "Aggiungi un farmaco da modifica ricetta":
      "Add a medicine in edit prescription",
    "Stampa fatture": "Print invoices",
    "La dimensione del documento è oltre i limiti di stampa":
      "The document size exceeds the print limits",
    "Non è possibile stampare più di [limit] fatture":
      "It is not possible to print more than {{limit}} invoices",
    "Operazione in corso: [progress]%": "Operation in progress: {{progress}}%",
    "Invia fatture": "Send invoices",
    "Invio fatture in corso": "Sending invoices in progress",
    "Stampa [count] fatture di [name]":
      "Printing {{count}} invoices of {{name}}",
    "Aggiunte le statistiche per metodo di pagamento":
      "Added payment statistics",
    "Aggiunta la possibilità di aggiungere al conto paziente dalla ricetta":
      "Added possibility to add patient to book from prescription",
    "Aggiunta la possibilità di stampare massivamente le fatture di un cliente":
      "Added possibility to print invoices of a customer",
    "Agginuta la categoria nell'estrazione di prestazioni":
      "Added category in extraction of services",
    "Ora l'agenda mostra gli appuntamenti in formato tabellare":
      "Now the agenda shows appointments in tabular format",
    "Aggiunta la possibilità di stampare la ricevuta degli incassi di una fattura":
      "Added possibility to print the receipt of an invoice",
    "Aggiunta la possibilità di inviare la ricevuta degli incassi di una fattura via email":
      "Added possibility to send the receipt of an invoice via email",
    "Ora i tab dei clienti/pazienti mostrano il titolo più chiaramente":
      "Now the tabs of customers/patients show the title more clearly",
    "Nella vista risorse dell'agenda vengono mostrati di default lo staff in turno":
      "In the agenda resources view, the staff in turn is shown by default",
    "Non è possibile stampare più di [limit] giorni di appuntamenti":
      "It is not possible to print more than {{limit}} days of appointments",
    Ora: "Time",
    Riconfezionamento: "Packaging",
    "Arrotondamento commerciale": "Commercial rounding",
    "Arrotondamento commerciale impostato in fattura":
      "Commercial rounding enabled in invoice",
    "Impossibile impostare l'arrotondamento commerciale in fattura":
      "It is not possible enable commercial rounding in invoice",
    "Arrotondamento commerciale disabilitato in fattura":
      "Commercial rounding disabled in invoice",
    "Impossibile disabilitare l'arrotondamento commerciale in fattura":
      "It is not possible disable commercial rounding in invoice",
    "Piano dei conti": "Chart of accounts",
    "Codice Ditta": "Company Code",
    "Conto Cliente (ricavi)": "Customer Account (Revenue)",
    "Conto Fornitore (costi)": "Supplier Account (Costs)",
    "IVA Vendita": "Sales VAT",
    "Conto con Ritenuta d'acconto": "Account with Withholding Tax",
    "Conto senza Ritenuta d'acconto": "Account without Withholding Tax",
    "Conto esente IVA": "VAT-exempt Account",
    "Conto predefinito": "Default Account",
    "Conto prestazioni veterinarie - IVA 22%":
      "Veterinary Services Account - 22% VAT",
    "Conto cessione farmaci - IVA 10%": "Drug Sales Account - 10% VAT",
    "Conto articoli vari/prodotti - IVA 4%":
      "Various Items/Products Account - 4% VAT",
    "Cassa contanti": "Cash Register",
    Banca: "Bank",
    "Codici IVA": "VAT Codes",
    "Conti ricavo netto (imponibili)": "Net Revenue Accounts (Taxable)",
    "Conti patrimoniali": "Balance Sheet Accounts",
    Posizione: "Position",
    Assistente: "Assistant",
    "Eseguito da fatturare": "Executed to invoice",
    "Eseguito totale": "Executed total",
    "Per l'appuntamento sono stati configurati un telefono e/o una mail differenti da quelli in anagrafica, vuoi aggiornarli?":
      "The phone and/or email configured for the appointment differ from those in the customer record. Do you want to update them?",
    "Per procedere, specificare il sesso":
      "In order to proceed, specify the patient sex",
    "Inserito da": "Added by",
    "Sono presenti delle notule importate": "There are imported draft invoices",
    "Primo semestre": "First semi-annual",
    "Secondo semestre": "Second semi-annual",
    Allega: "Attach",
    "Esporta le righe di fattura per metodo di pagamento selezionate in Excel":
      "Export selected payment method invoice lines to Excel",
    "Impossibile aggiungere l'acconto selezionato":
      "Cannot add the selected deposit",
    "Impossibile caricare i dati di utilizzo": "Unable to load usage data",
    "Impossibile caricare l'API key": "Unable to load API key",
    Integrazione: "Integration",
    "Copiato negli appunti": "Copied to clipboard",
    Copia: "Copy",
    "Le due modalità sono alternative e dipendono dallo strumento utilizzato":
      "The two methods are alternatives and depend on the tool used",
    "Metodo 1: Header x-api-key": "Method 1: Header x-api-key",
    "Metodo 2: Parametro query apiKey": "Method 2: Query param apiKey",
    "URL MCP": "MCP URL",
    "API Key": "API Key",
    "Esempio URL completo": "Full URL example",
    "Header da impostare: x-api-key": "Header to set: x-api-key",
    "Intro integrazione MCP":
      "You can integrate Snoots MCP in two ways. Choose the method based on your tool: some support custom HTTP headers, others only accept a URL with parameters.",
    "Intro metodo header":
      "Use this method if your tool supports setting custom HTTP headers.",
    "Nota metodo header":
      "The API key is sent in the x-api-key header with every request. More secure because the key does not appear in the URL.",
    "Intro metodo query":
      "Use this method if your tool only accepts a URL and does not allow configuring additional headers.",
    "Nota metodo query":
      "The API key is included in the URL. Avoid sharing the full URL as it contains the key.",
    "Hai utilizzato un acconto incassato con un profilo fiscale differente.":
      "You have used a deposit collected with a different tax profile",
    "Performance economica": "Economic performance",
    "Clienti e pazienti": "Customers and patients",
    "Efficienza operativa": "Operational efficiency",
    "Qualità e soddisfazione": "Quality and satisfaction",
    "Ticket medio": "Average ticket",
    "Fatturato medio per contatto": "Average revenue per contact",
    "Fatturato medio per paziente": "Average revenue per patient",
    "Pazienti entrati in clinica": "Patients admitted to clinic",
    "Tasso di crescita contatti": "Contact growth rate",
    "Prestazioni per paziente": "Services per patient",
    "Tempo di attesa medio": "Average waiting time",
    "Tempo di permanenza medio": "Average length of stay",
    "Soddisfazione clienti": "Customer satisfaction",
    "Valore medio delle fatture": "Average invoice value",
    "Importo medio fatturato per contatto": "Average billed amount per contact",
    "Importo medio fatturato da ciascun veterinario":
      "Average billed amount per veterinarian",
    "Importo medio fatturato per ogni paziente":
      "Average billed amount per patient",
    "Numero di pazienti entrati in clinica nel periodo":
      "Number of patients admitted to the clinic during the period",
    "Rapporto tra numero di pretazione e numero di pazienti":
      "Ratio between number of services and number of patients",
    "Media durata in minuti, eccetto i pazienti in degenza":
      "Average duration in minutes, excluding hospitalized patients",
    "Media della soddisfazione cliente nel periodo":
      "Average customer satisfaction during the period",
    "Membro dello staff": "Staff member",
    e: "and",
    giorno: "day",
    giorni: "days",
    mese: "month",
    mesi: "months",
    anno: "year",
    anni: "years",
    "Il paziente ha un acconto non ancora consumato":
      "The patient has an unused advance payment",
    "Abilita per continuare": "Please enable to proceed",
    "Seleziona un provider per compilare i campi":
      "Choose a provider to complete the form",
    "La fattura non è compatibile con il regime forfettario scelto: alcune prestazioni non sono esenti IVA. Procedere comunque?":
      "The invoice is not compatible with the chosen flat-rate scheme: some services are not VAT-exempt. Do you wish to proceed anyway?",
    "Più opzioni": "More options",
    "È stato trovato un acconto di [remainingAmount] non ancora utilizzato.":
      "An advance payment of {{remainingAmount}} that has not yet been used has been found.",
    "L'acconto presenta i seguenti parziali già assegnati:":
      "The advance payment has the following partial assignments:",
    "L'acconto è già assegnato in una notula:":
      "The advance payment is already assigned in a draft:",
    "Esiste già una notula per questo cliente.":
      "There is already a draft invoice for this customer.",
    "Trovata una notula sul cliente":
      "A draft invoice was found for this customer.",
    "Continua la fatturazione nella notula esistente. Le prestazioni verranno aggiunte alla notula.":
      "Continue invoicing in the existing draft invoice. Services will be moved to the draft.",
    Apri: "Open",
    "Non mostrare più": "Don’t show again",
    "Crediti per invio email esauriti": "Email sending credits exhausted",
    Autorizzazioni: "Authorizations",
    "I campi contrassegnati con • sono necessari per l'esportazione verso Zucchetti o Team System.":
      "Fields marked with • are required for export to Zucchetti or Team System.",
    Gratuito: "Free",
    "Totale insoluto": "Total outstanding",
    "Stampa riepilogo": "Print summary",
    "Visualizza risultato": "View result",
    "Sei sicuro di voler eliminare [count] notule?":
      "Are you sure you want to delete {{count}} draft invoices?",
    "Elimina notule": "Delete draft invoices",
    "Check In rapido": "Quick Check In",
    "Scegliere cosa includere nella stampa:":
      "Choose what to include in the print:",
    "Tutte le voci (fatturate e da fatturare)": "All items (paid and unpaid)",
    "Solo voci da fatturare": "Unpaid items",
    "Solo voci già fatturate": "Paid items"
  },
  fr: {}
};
